/**
 * Adds lightweight client-side search and filters to Support resource and blog lists.
 */
class SupportCenterFilters {
  constructor(root) {
    this.root = root;
    this.items = [...root.querySelectorAll('[data-support-item]')];
    this.emptyState = root.querySelector('[data-support-empty]');
    this.search = root.querySelector('[data-support-search]');
    this.productFilter = root.querySelector('[data-support-product-filter]');
    this.typeFilter = root.querySelector('[data-support-type-filter]');
    this.blogButtons = [...root.querySelectorAll('[data-support-blog-filter]')];
    this.activeBlogCategory = 'all';
    this.bindEvents();
    this.apply();
  }

  bindEvents() {
    this.search?.addEventListener('input', () => this.apply());
    this.productFilter?.addEventListener('change', () => this.apply());
    this.typeFilter?.addEventListener('change', () => this.apply());

    this.blogButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.activeBlogCategory = button.dataset.supportBlogFilter || 'all';
        this.blogButtons.forEach((candidate) => {
          candidate.setAttribute('aria-pressed', String(candidate === button));
        });
        this.apply();
      });
    });
  }

  apply() {
    const query = this.search?.value.trim().toLocaleLowerCase() || '';
    const product = this.productFilter?.value || 'all';
    const type = this.typeFilter?.value || 'all';
    let visibleCount = 0;

    this.items.forEach((item) => {
      const itemText = item.textContent.toLocaleLowerCase();
      const itemProduct = item.dataset.productCategory || 'all';
      const itemType = item.dataset.resourceType || 'all';
      const itemBlogCategory = item.dataset.blogCategory || 'all';
      const matchesQuery = !query || itemText.includes(query);
      const matchesProduct = product === 'all' || itemProduct === 'all' || itemProduct === product;
      const matchesType = type === 'all' || itemType === type;
      const matchesBlog = this.activeBlogCategory === 'all' || itemBlogCategory === this.activeBlogCategory;
      const visible = matchesQuery && matchesProduct && matchesType && matchesBlog;

      item.classList.toggle('is-filtered-out', !visible);
      if (visible) visibleCount += 1;
    });

    this.emptyState?.classList.toggle('is-visible', visibleCount === 0);
  }
}

document.querySelectorAll('[data-support-root]').forEach((root) => new SupportCenterFilters(root));
